import { useSearchParams } from '@remix-run/react';
import { teamStore } from '~/lib/stores/team';

export function useClearUpdateTeamData() {
  const [searchParams, setSearchParams] = useSearchParams();

  return () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('upgradeTeamMember');
    setSearchParams(newParams);
    teamStore.updateTeamData.set(null);
  };
}
